var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39082_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2217 2.49988L19.16 16.2499C19.2332 16.3766 19.2717 16.5203 19.2717 16.6665C19.2717 16.8128 19.2332 16.9565 19.16 17.0832C19.0869 17.2099 18.9817 17.3151 18.855 17.3882C18.7283 17.4614 18.5846 17.4999 18.4384 17.4999H2.56171C2.41543 17.4999 2.27173 17.4614 2.14505 17.3882C2.01837 17.3151 1.91317 17.2099 1.84003 17.0832C1.7669 16.9565 1.72839 16.8128 1.72839 16.6665C1.72839 16.5203 1.7669 16.3766 1.84004 16.2499L9.77837 2.49988C9.85151 2.37321 9.95671 2.26802 10.0834 2.19489C10.2101 2.12175 10.3538 2.08325 10.5 2.08325C10.6463 2.08325 10.79 2.12175 10.9167 2.19489C11.0434 2.26802 11.1486 2.37321 11.2217 2.49988ZM4.00504 15.8332H16.995L10.5 4.58322L4.00504 15.8332ZM9.6667 13.3332H11.3334V14.9999H9.6667V13.3332ZM9.6667 7.49988H11.3334V11.6665H9.6667V7.49988Z",
    fill: "#FF3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39082_639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLine);
export default __webpack_public_path__ + "static/media/alert-line.895fd3beac85d4bfe08dd22f516b6194.svg";
export { ForwardRef as ReactComponent };